import React from "react";
import "./style.scss";

import { useTranslation } from "react-i18next";
import Reservations from "./Reservations";
import { TbCalendarStats } from "react-icons/tb";

const AccountReservation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="account-tickets">
        <h5 className="ticket-title flex-start-center">
          <TbCalendarStats   className="icon" />
          {t("najblizsze_rezerwacje")}
        </h5>

        <div className="flex-start flex-wrap">
          <Reservations />
        </div>
      </div>
    </>
  );
};

export default AccountReservation;
